<div *ngFor="let version of versions"
     class="changelogs-menu">
  <div class="changelogs-menu-item"
       [ngClass]="{'selected' : isVersionSelected(version)}"
       (click)="this.toggleSubVersionOpen(version.number); this.selectVersion(version);">
    <i class="changelogs-icon fas {{ defaultIconClass(version) }}"
      [ngClass]="{
       'fa-chevron-right' : version.subVersions.length > 0 && !checkIfSubVersionOpen(version.number),
       'fa-chevron-down' : version.subVersions.length > 0 && checkIfSubVersionOpen(version.number)
      }"></i>
    <span class="changelogs-menu-item-text">{{ version.number }}</span>
  </div>
  <div *ngFor="let subVersion of version.subVersions"
        class="changelogs-menu-list"
        [ngClass]="{
          'changelogs-menu-list-open': checkIfSubVersionOpen(version.number),
          'changelogs-menu-list-closed': !checkIfSubVersionOpen(version.number)
          }">
    <ul class="changelogs-menu-sublist"
        (click)="this.selectVersion(subVersion);">
      <li class="changelogs-menu-item"
          [ngClass]="{'selected' : isVersionSelected(subVersion)}">
        <span class="changelogs-menu-item-text">{{ subVersion.number }}</span>
      </li>
    </ul>
  </div>
</div>
